export default __webpack_public_path__ + "static/media/logo_black2.b2df6ff9.png";